import React from 'react';
import Footer from './Footer';
import Carousel from 'react-bootstrap/Carousel'
import { Link } from 'react-router-dom';
export default function Home() {
   return (
      <>
         <main id="main">
         {/* <section id="contact" class="contact1"> */}
               {/* <div class="container"> */}
                  <div class="row faq-item d-flex align-items-stretch">
                           <div class="col-lg-10">
                              {/* <div style={{ display: 'block', width: 950, padding: 30 }}> */}
                              <Carousel className='Carousel'>
                                 <Carousel.Item interval={2000}>
                                    <img className="d-block w-100 carouselimg" src="assets/img/slide/slide-24.png" alt="First slide" />
                                 </Carousel.Item>
                                 <Carousel.Item interval={2000}>
                                    <img className="d-block w-100 carouselimg" src="assets/img/slide/slide-21.png" alt="Second slide" />
                                 </Carousel.Item>
                                 <Carousel.Item interval={2000}>
                                    <img className="d-block w-100 carouselimg" src="assets/img/slide/slide-22.png" alt="Third slide" />
                                 </Carousel.Item>
                                 <Carousel.Item interval={2000}>
                                    <img className="d-block w-100 carouselimg" src="assets/img/slide/slide-23.png" alt="Forth slide" />
                                 </Carousel.Item>
                                 <Carousel.Item interval={2000}>
                                    <img className="d-block w-100 carouselimg" src="assets/img/slide/amit-2.jpeg" alt="Five slide" />
                                 </Carousel.Item>
                              
                              </Carousel>
                              {/* </div> */}
                           </div>
                           <div class="col-lg-2">
                           {/* <div class="row"> */}
                                 {/* <div class="col-md-6">   */}
                                 {/* <video width="202.5" height="290" controls>
                                    <source src="assets/img/slide/video1.mp4" type="video/mp4" />
                                 </video> */}
                                 <h5 className='card-title1'>कार्यक्रम </h5>
                                 <ol>
                                    <li>
                                    <b> चातुर्मास्यव्रतानुष्ठान </b><br></br> वि. सं. २०८०, आषाढ़ शुक्ल पूर्णिमा से भाद्रपद शुक्ल पूर्णिमा तदानुसार <br></br>
                                    <u>दिनांक : ३ जुलाई २०२३ से  २९ सितम्बर २०२३ </u>
                                       </li>
                                    {/* <li>अरूणाचल प्रदेश <br></br>Dt. 07-08-2023 to 18-08-2023&nbsp;</li> */}
                                 </ol>
                                          {/* </div> */}
                                 {/* </div> */}
                           </div>
                           {/* <div class="col-lg-1"></div> */}

                        
                  </div>
               {/* </div> */}
          {/* </section> */}
          
            <section id="contact" class="contact1">
               <div class="container">
                  <div class="row faq-item d-flex align-items-stretch">
                     <div class="col-lg-4">
                        <div class="row">
                        <div class="col-md-12" style={{backgroundcolor:"lightgrey", width:"350px",height:"280px",border:"5px solid  #EEE9DA",padding: "10px",margin: "20px"}}>
                           <div className='card-title2'>
                           <h5> &nbsp; लेटेस्ट न्यूज़ </h5>
                           <button style={{border:"1px solid white",marginBottom:"8px",marginLeft:"160px"}} > 
                           <a href='/Video'>View all</a> </button>
                           </div>
                           {/* <h1 className='card-title2'>लेटेस्ट न्यूज़ </h1>
                           <button> <a href='/Video' className="btn1" >Latest Video</a> </button> */}
                           <marquee width="100%" behavior="scroll" direction="up"scrolldelay="500" 
                           height="80%">  
                           <ul>
                              <li> <a href="https://youtu.be/Ll5B33fO-9s" target={"_blank"}>चातुर्मास्यव्रतानुष्ठान जगद्गुरु शंकराचार्य जी के आशीर्वचन श्रीमद्भागवत गीता,भाग-1 शारदापीठ द्वारका</a> </li>
                              <li> <a href="https://youtu.be/HUDNKhksvL0" target={"_blank"}>चातुर्मास्यव्रतानुष्ठान जगद्गुरु,शंकराचार्य जी के आशीर्वचन श्रीमद्भागवत गीता, भाग-2 द्वारका गुजरात।</a> </li>
                              <li> <a href="https://www.youtube.com/live/NczV47lUQXo?feature=share" target={"_blank"}>चातुर्मास्यव्रतानुष्ठान जगद्गुरु,शंकराचार्य जी के आशीर्वचन श्रीमद्भागवत गीता, भाग-3 द्वारका गुजरात।</a> </li>
                           </ul>
                             
                              </marquee>  
                              {/* <marquee width="100%" behavior="scroll" direction="up"scrolldelay="500" 
                           height="100%">  
                              pqr  
                              </marquee> 
                             <marquee width="100%" behavior="scroll" direction="up"scrolldelay="500" 
                           height="100%">  
                            
                            </marquee>   */}

                              

                        {/* <video width="202.5" height="360" controls>
                           <source src="assets/img/slide/video.mp4" type="video/mp4" />
                        </video>  */}
                        </div>
                       {/* <div class="col-md-6">  
                        <video width="202.5" height="360" controls>
                           <source src="assets/img/slide/video1.mp4" type="video/mp4" />
                        </video>
                        </div>
                        <div style={{ display: 'flex',marginLeft:"35%" , alignItems: 'center'}} >
                           <a href='/Video'  className="btn btn-primary"  >More Video</a>
                        </div> */}
                        </div>
                        {/* 
         </div> style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
         className="btn btn-primary"
         */}
                        {/* <i class="bx bx-help-circle"></i>
         <h4>Tempus quam pellentesque nec nam aliquam sem et tortor consequat?</h4>
         */}
                     </div>

                     <div class="col-lg-8">
                        {/* 
         <h2 class="animate__animated animate__fadeInDown"><span>भूमिका</span></h2>
         */}
                        <div class="text-center">
                           <h1> मठ </h1>
                        </div>
                        <p style={{ textIndent: "50px", textAlign: "justify" }}><b>'मठ' </b> शब्द धार्मिक प्रतिष्ठान का पर्याय बन चुका है। हैमकोश के अनुसार 'आम्नाय पद का अर्थ कुल, आगम और उपदेश है। अमरकोश इसका एक अर्थ सम्प्रदाय' बतलाता है। भानुजी दीक्षित (रामाश्रम) अपनी टीका में निर्गलित अर्थ 'गुरुपरम्परागत सदुपदेश" देते हैं । अतः वर्तमान सन्दर्भ में 'मठाम्नाव' का अर्थ होगा 'मठों से सम्बद्ध उपदेश अथवा विवरण। 'अनुशासन' पद निर्देश, व्यवस्था, नियन्त्रण सदृश अर्थों का वाचक है। इसमें लगा उपपद 'महा' अनुशासन की सर्वोत्कृष्टता, का सर्वोच्चता श्रेष्ठता का, ज्ञापक है। 'मठाम्नाय महानुशासन का निलित अर्थ हुआ वह ग्रन्थ जिसमें शाङ्कर मठों से सम्बद्ध विवरण और व्यवस्था का निरूपण है । इसका एक नामान्तर 'मठाम्नाय- सेतु' भी प्राप्त होता है। 'आम्नाय पद मात्र 'उपदेश' या परम्परा का वाचक न रह कर सम्बद्ध मठ का भी वाचक हो गया, जैसा कि ऊर्ध्वाम्नाय, पश्चिमाम्नाय सदृश प्रयोगों से स्पष्ट है। वस्तुतः 'मठाम्नाव' एवं 'महानुशासन' पृथक-पृथक नहीं अपितु एक ही ग्रन्थ है। सप्तम 'निष्कल-आम्नाय' का निरूपण करने के तत्काल बाद ही 'महानुशासन' अंश प्रारम्भ होता है- </p>
                        {/* <p class="text-center" >
                           <b>आम्नायाः कथिता ह्येते यतीनां च पृथक् पृथक् । <br></br>
                              तैः सर्वैश्चतुराचार्यैर्नियोगेन यथाक्रमम् ।।४८ ।।   <br></br> </b>
                        </p> */}
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                           <a href='/Math' className="btn btn-primary" > Read More</a>
                        </div>
                     </div>
                  </div>
               </div>
            </section>
         </main>
         {/* <div id="network">
            <h2><a href="/Globalnetwork">Global Network</a></h2>
            <div className='networkbottom'>
               <a href="#" className='card'>
                  <img src="/assets/img/slide/1.jpg" alt="card image cap" className='card-img-top' />
                  <h4 className='card-title'>द्वारका,गुजरात</h4>
               </a>
               <a href="#" className='card'>
                  <img src="/assets/img/slide/2.jpg" alt="card image cap" className='card-img-top' />
                  <h4 className='card-title'>ज्योतिर्मठ, उत्तराञ्चल</h4>
               </a>
               <a href="#" className='card'>
                  <img src="/assets/img/slide/3.jpg" alt="card image cap" className='card-img-top' />
                  <h4 className='card-title'>शृंगेरी शारदा पीठ,कर्नाटक </h4>
               </a>
               <a href="#" className='card'>
                  <img src="/assets/img/slide/5.jpg" alt="card image cap" className='card-img-top' />
                  <h4 className='card-title'>गोवर्धन पीठ, पुरी</h4>
               </a>
               <a href="#" className='card'>
                  <img src="/assets/img/slide/6.jpg" alt="card image cap" className='card-img-top' />
                  <h4 className='card-title'>चमोली,उत्तराखंड</h4>
               </a>
            </div>
            
         </div> */}
          <div id="network">
            <h2><a href="/Video">चातुर्मास्यव्रतानुष्ठान जगद्गुरु शंकराचार्य जी के आशीर्वचन श्रीमद्भागवत गीता,द्वारका गुजरात।</a></h2>
            <div className='networkbottom'>
               <a href="https://youtu.be/Ll5B33fO-9s" target={"_blank"} className='card' >
               <iframe className='card-img-top'  src="https://www.youtube.com/embed/Ll5B33fO-9s?autoplay=1&mute=1" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                   <h5 className='card-title'>भाग-1</h5>
               </a>
               <a href="https://youtu.be/HUDNKhksvL0" target={"_blank"} className='card' >
               <iframe className='card-img-top'  src="https://www.youtube.com/embed/HUDNKhksvL0?autoplay=1&mute=1" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                   <h5 className='card-title'>भाग-2</h5>
               </a>
               <a href="https://www.youtube.com/live/NczV47lUQXo?feature=share" target={"_blank"} className='card' >
               <iframe className='card-img-top'  src="https://www.youtube.com/embed/NczV47lUQXo?autoplay=1&mute=1" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                   <h5 className='card-title'>भाग-3</h5>
               </a>
               <a href="https://www.youtube.com/live/xXF1WS61OFI?feature=share" target={"_blank"} className='card' >
               <iframe className='card-img-top'  src="https://www.youtube.com/embed/xXF1WS61OFI?autoplay=1&mute=1" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                   <h5 className='card-title'>भाग-4</h5>
               </a>
               <a href="https://www.youtube.com/live/o6YFBz4-4X0" target={"_blank"} className='card' >
               <iframe className='card-img-top'  src="https://www.youtube.com/embed/o6YFBz4-4X0?autoplay=1&mute=1" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                   <h5 className='card-title'>भाग-5</h5>
               </a> 
                {/* <div style={{ display: 'flex',marginLeft:"35%" , alignItems: 'center'}} > */}
                           {/* <button className='card'> <a href='/Video' className="btn1" >Latest Video</a> </button> */}
                           
                        {/* </div>                */}
                 {/* <button className='card'> <a href='/Video' className="btn1" >Latest Video</a> </button> */}

                  {/* <div style={{ display: 'flex',marginLeft:"35%" , alignItems: 'center'}} > */}
                           {/* <button className='card'> <a href='/Video' className="btn1" >Latest Video</a> </button> */}
                           
                        {/* </div>                */}
            </div>
            
         </div>

      </>
   );
}